import { Validator, rules } from "@lchemy/model/validation";

export interface UpdateUserInfoCmd {
  name?: string;
  password?: string;
  passwordConfirm?: string;

  existingPassword?: string;
}

export const updateUserInfoCmdValidator = new Validator<UpdateUserInfoCmd>({
  name: [rules.isString()],
  password: [
    rules.isString(),
    rules.checkIf((str) => str != null && str.length > 0, [rules.minLength(5)])
  ],
  passwordConfirm: [
    rules.checkIf<string, UpdateUserInfoCmd>(
      (_, cmd) => cmd.password != null && cmd.password.length > 0,
      [rules.required()]
    ),
    rules.isString(),
    (confirm, model) => (confirm === model.password ? null : { confirm: true })
  ]
});
